import { ArrowDown } from 'lucide-react';
import { T } from '../../i18n/copy';
import Reveal from '../Reveal';
import SectionHead from '../SectionHead';

export default function PointOfView({ lang }) {
  const t = T.pov;
  return (
    <section data-header-theme="bone" data-testid="pov-section" className="editorial-margins bg-bone py-8 md:py-12">
      <SectionHead eyebrow={t.eyebrow[lang]} index={t.index} />
      <div className="mt-10 grid grid-cols-1 gap-10 lg:grid-cols-12">
        <div className="lg:col-span-7">
          <Reveal>
            <h2 className="whitespace-pre-line font-tight font-semibold text-[clamp(2rem,4.2vw,3.9rem)] leading-[1.06] tracking-[-0.02em] text-midnight">
              {t.headline[lang]}
            </h2>
          </Reveal>
        </div>
        <div className="max-w-md space-y-5 text-base leading-relaxed text-midnight/70 lg:col-span-5 lg:pt-2">
          <Reveal delay={0.1}>
            <p>{t.body1[lang]}</p>
            <p className="mt-4">{t.body2[lang]}</p>
            <p className="mt-4">{t.body3[lang]}</p>
          </Reveal>
        </div>
      </div>

      <Reveal className="mt-8 border-t border-midnight/15 pt-6 md:mt-10" testid="pov-chain">
        <div className="grid grid-cols-2 gap-x-6 gap-y-6 sm:grid-cols-[1fr_auto_1fr_auto_1fr_auto_1fr] sm:gap-4">
          {t.chain[lang].map((c, i) => (
            <div key={c.label}>
              <p className="text-[14px] font-semibold uppercase tracking-[0.08em] text-midnight">{c.label}</p>
              <p className="mt-2 text-base leading-relaxed text-steel-dark">{c.q}</p>
            </div>
          ))}
        </div>
      </Reveal>

      <div className="mt-6 flex items-start gap-3 md:mt-8">
        <ArrowDown className="mt-1.5 h-4 w-4 shrink-0 text-vermilion" strokeWidth={1.5} />
        <p className="font-serif text-xl text-midnight md:text-2xl" data-testid="pov-supporting">{t.supporting[lang]}</p>
      </div>
    </section>
  );
}
